module.exports = __webpack_public_path__ + "img/1479937064.4160469a.jpg";